import { node, oneOfType, arrayOf } from 'prop-types';

export const children = type => oneOfType([arrayOf(type), type]);

export const childrenPropType = children(node);
